var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthenAccountIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2949_26009",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 11.5C24.5 15.0913 21.5912 18 18 18C14.4087 18 11.5 15.0913 11.5 11.5C11.5 7.90875 14.4087 5 18 5C21.5912 5 24.5 7.90875 24.5 11.5ZM21.25 11.5006C21.25 9.71313 19.7875 8.25063 18 8.25063C16.2125 8.25063 14.75 9.71313 14.75 11.5006C14.75 13.2881 16.2125 14.7506 18 14.7506C19.7875 14.7506 21.25 13.2881 21.25 11.5006ZM18 19.625C13.6613 19.625 5 21.8025 5 26.125V29.375C5 30.2687 5.73125 31 6.625 31H29.375C30.2687 31 31 30.2687 31 29.375V26.125C31 21.8025 22.3388 19.625 18 19.625ZM8.24968 26.1419V27.7506H27.7497V26.1256C27.4247 24.9719 22.3872 22.8756 17.9997 22.8756C13.6122 22.8756 8.57468 24.9719 8.24968 26.1419Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2949_26009)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 26,
    height: 26,
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenAccountIconSvg);
export default __webpack_public_path__ + "static/media/authen-account-icon-svg.e503efc5.svg";
export { ForwardRef as ReactComponent };